module.exports = __webpack_public_path__ + "img/avatar.7b17ac1a.svg";